// 真实印尼候选人信息（前端静态数据）
// 与数据库候选人 ID 一一对应，仅替换展示信息，投票数据仍从后端获取
export const REAL_CANDIDATES = [
  {
    id: 'ipip1',
    company: 'IPIP',
    code: 'IPIP-00180',
    name: '李嘉格',
    nameId: 'RASIDI',
    dept: '物流事业部',
    deptId: 'Dept. Logistik Bisnis',
    position: 'LBD Staff',
    itemDesc: '1、年度出勤率：100.00%\n2、突出表现：\n（1）业绩突出\n（2）融合互助、见义勇为\n（3）奉献担当\n3、业绩说明：\n熟练掌握专业词汇与技术知识；作为现场副班长兼翻译，能有效沟通中印尼双方技术交流，准确处理现场技术问题。',
    descId: '1、Tingkat Kehadiran Tahunan：100.00%\n2、Kinerja Menonjol：\n（1）Prestasi Kerja Menonjol\n（2）Gotong Royong Lintas Budaya & Berani Membela Keadilan\n（3）Bertanggung Jawab & Berpengabdian\n3、Uraian Kinerja：\nMenguasai kosakata profesional dan pengetahuan teknis dengan sangat baik; sebagai koordinator lapangan sekaligus penerjemah, mampu menjembatani komunikasi teknis antara karyawan Tiongkok dan Indonesia serta menangani masalah teknis di lapangan secara tepat.',
    coverUrl: '/static/person/ipip1/photo.PNG',
    poster: '/static/person/ipip1/photo.PNG',
    videoUrl: '/static/person/ipip1/video.mp4'
  },
  {
    id: 'ipip2',
    company: 'IPIP',
    code: 'IPIP-00425',
    name: 'Hasni Yulianti',
    nameId: 'Hasni Yulianti',
    dept: '人力资源部（印尼）',
    deptId: 'Dept. Sumber Daya Manusia',
    position: 'Recruitment Specialist',
    itemDesc: '1、年度出勤率：100.00%\n2、突出表现：\n（1）业绩突出\n（2）创新改进\n（3）奉献担当\n3、业绩说明：\n能在压力下保持良好工作状态；作为招聘专员，认真筛选候选人，积极协调各部门用工需求，确保招聘流程按时完成。',
    descId: '1、Tingkat Kehadiran Tahunan：100.00%\n2、Kinerja Menonjol：\n（1）Prestasi Kerja Menonjol\n（2）Inovasi & Perbaikan Kerja\n（3）Bertanggung Jawab & Berpengabdian\n3、Uraian Kinerja：\nMampu bekerja dengan baik di bawah tekanan; sebagai spesialis rekrutmen, teliti dalam menyeleksi calon karyawan, aktif berkoordinasi dengan berbagai departemen untuk memenuhi kebutuhan tenaga kerja, dan memastikan proses rekrutmen berjalan tepat waktu.',
    coverUrl: '/static/person/ipip2/photo.jpeg',
    poster: '/static/person/ipip2/photo.jpeg',
    videoUrl: '/static/person/ipip2/video.mp4'
  },
  {
    id: 'ipip3',
    company: 'IPIP',
    code: 'IPIP-00428',
    name: 'Al Haerik, A.Md.Kep',
    nameId: 'Al Haerik, A.Md.Kep',
    dept: '应急管理办公室',
    deptId: 'Dept. EHSS',
    position: 'Occupational Health Specialist',
    itemDesc: '1、年度出勤率：100.00%\n2、突出表现：\n（1）奉献担当\n3、业绩说明：\n积极协调中印尼双方同事，开展跨部门沟通协作，参与现场工作交接；利用交接时间开展健康教育，为员工测量血压、心率等健康指标，推动员工养成健康生活方式，降低工伤事故发生率。',
    descId: '1、Tingkat Kehadiran Tahunan：100.00%\n2、Kinerja Menonjol：\n（1）Bertanggung Jawab & Berpengabdian\n3、Uraian Kinerja：\nSecara aktif berkoordinasi dengan rekan kerja Tiongkok dan Indonesia, melakukan komunikasi lintas departemen, dan berpartisipasi dalam serah terima pekerjaan di lapangan. Memanfaatkan waktu serah terima untuk memberikan edukasi kesehatan serta melakukan pemeriksaan tekanan darah, detak jantung, dan indikator kesehatan lainnya. Berfokus pada penerapan pola hidup sehat bagi karyawan guna mengurangi risiko kecelakaan kerja.',
    coverUrl: '/static/person/ipip3/photo.jpeg',
    poster: '/static/person/ipip3/photo.jpeg',
    videoUrl: '/static/person/ipip3/video.mp4'
  },
  {
    id: 'ipip4',
    company: 'IPIP',
    code: 'IPIP-00434',
    name: 'Ricki Ardhi Setya Ardiyanto',
    nameId: 'Ricki Ardhi Setya Ardiyanto',
    dept: '物流事业部',
    deptId: 'Dept. Logistik Bisnis',
    position: 'Vice Foreman Safety',
    itemDesc: '1、年度出勤率：99.73%\n2、突出表现：\n（1）业绩突出\n（2）奉献担当\n3、业绩说明：\n安全专业技术知识扎实，能有效带领安全团队开展日常巡检工作，推动部门各项安全工作计划落地。',
    descId: '1、Tingkat Kehadiran Tahunan：99.73%\n2、Kinerja Menonjol：\n（1）Prestasi Kerja Menonjol\n（2）Bertanggung Jawab & Berpengabdian\n3、Uraian Kinerja：\nMemiliki pengetahuan teknis keselamatan kerja yang profesional; mampu memimpin tim safety dengan baik, melaksanakan inspeksi rutin, dan menjalankan program kerja yang ingin dicapai departemen.',
    coverUrl: '/static/person/ipip4/photo.jpg',
    poster: '/static/person/ipip4/photo.jpg',
    videoUrl: '/static/person/ipip4/video.mp4'
  },
  {
    id: 'ipip5',
    company: 'IPIP',
    code: 'IPIP-00439',
    name: 'MELANI',
    nameId: 'MELANI',
    dept: '办公室',
    deptId: 'Dept. Kantor',
    position: 'Staff',
    itemDesc: '1、年度出勤率：100.00%\n2、突出表现：\n（1）创新改进\n（2）奉献担当\n（3）进取成长\n3、业绩说明：\n能够胜任安保部门行政支持工作；作为翻译准确沟通部门内外部事务，保障日常行政工作顺利开展。',
    descId: '1、Tingkat Kehadiran Tahunan：100.00%\n2、Kinerja Menonjol：\n（1）Inovasi & Perbaikan Kerja\n（2）Bertanggung Jawab & Berpengabdian\n（3）Selalu Berkembang & Belajar\n3、Uraian Kinerja：\nMampu mendukung administrasi di divisi keamanan; sebagai penerjemah, menjembatani komunikasi internal maupun eksternal divisi keamanan dengan akurat, serta membantu kelancaran tugas administrasi harian.',
    coverUrl: '/static/person/ipip5/photo.png',
    poster: '/static/person/ipip5/photo.png',
    videoUrl: '/static/person/ipip5/video.mp4'
  },
  {
    id: 'ipip6',
    company: 'IPIP',
    code: 'IPIP-00442',
    name: '法力色',
    nameId: 'FAHRI GUNAWAN',
    dept: '仓储部',
    deptId: 'Dept. Gudang',
    position: 'Staff Statistik',
    itemDesc: '1、年度出勤率：99.45%\n2、突出表现：\n（1）奉献担当\n（2）进取成长\n3、业绩说明：\n跨部门沟通协调能力强；作为统计员，能准确处理仓储数据，在各项工作任务中高效完成协调工作。',
    descId: '1、Tingkat Kehadiran Tahunan：99.45%\n2、Kinerja Menonjol：\n（1）Bertanggung Jawab & Berpengabdian\n（2）Selalu Berkembang & Belajar\n3、Uraian Kinerja：\nMemiliki kemampuan komunikasi dan koordinasi lintas departemen yang kuat; sebagai staf statistik, mampu mengolah data gudang secara akurat dan menyelesaikan tugas koordinasi secara efektif dalam berbagai penugasan kerja.',
    coverUrl: '/static/person/ipip6/photo.jpeg',
    poster: '/static/person/ipip6/photo.jpeg',
    videoUrl: '/static/person/ipip6/video.mp4'
  },
  {
    id: 'ipip7',
    company: 'IPIP',
    code: 'IPIP-00453',
    name: '蔡明玉',
    nameId: 'ANGELINA',
    dept: '物流事业部',
    deptId: 'Dept. Logistik Bisnis',
    position: 'Vice Supervisor & Translator',
    itemDesc: '1、年度出勤率：99.18%\n2、突出表现：\n（1）业绩突出\n（2）奉献担当\n（3）进取成长\n3、业绩说明：\n具备良好的协调能力，能有效安排车辆调度与排班，圆满完成上级交办的各项任务，成果令人满意。',
    descId: '1、Tingkat Kehadiran Tahunan：99.18%\n2、Kinerja Menonjol：\n（1）Prestasi Kerja Menonjol\n（2）Bertanggung Jawab & Berpengabdian\n（3）Selalu Berkembang & Belajar\n3、Uraian Kinerja：\nMemiliki keterampilan koordinasi yang baik; mampu mengatur pengiriman dan penjadwalan kendaraan secara efektif, serta menyelesaikan tugas yang didelegasikan atasan dengan hasil memuaskan.',
    coverUrl: '/static/person/ipip7/photo.jpg',
    poster: '/static/person/ipip7/photo.jpg',
    videoUrl: '/static/person/ipip7/video.mp4'
  },
  {
    id: 'ipip8',
    company: 'IPIP',
    code: 'IPK-00004',
    name: 'Beatrice Indry Wahyuni',
    nameId: 'Beatrice Indry Wahyuni',
    dept: '港口事业部',
    deptId: 'Dept. Pelabuhan',
    position: 'Port Staff',
    itemDesc: '1、年度出勤率：99.73%\n2、突出表现：\n（1）业绩突出\n（2）奉献担当\n3、业绩说明：\n工作态度端正，执行力强，团队协作良好；作为文员，认真管理港口运营文件与数据。',
    descId: '1、Tingkat Kehadiran Tahunan：99.73%\n2、Kinerja Menonjol：\n（1）Prestasi Kerja Menonjol\n（2）Bertanggung Jawab & Berpengabdian\n3、Uraian Kinerja：\nMemiliki etos kerja yang baik, kemampuan pelaksanaan tugas yang tinggi, dan kolaborasi yang baik dalam tim; sebagai admin, teliti dalam mengelola dokumen dan data operasional pelabuhan.',
    coverUrl: '/static/person/ipip8/photo.JPG',
    poster: '/static/person/ipip8/photo.JPG',
    videoUrl: '/static/person/ipip8/video.mp4'
  },
  {
    id: 'ipip9',
    company: 'IPIP',
    code: 'IPK-00067',
    name: 'Dedy Stalin Dammar',
    nameId: 'Dedy Stalin Dammar',
    dept: '港口事业部',
    deptId: 'Dept. Pelabuhan',
    position: 'Port Staff',
    itemDesc: '1、年度出勤率：99.73%\n2、突出表现：\n（1）业绩突出\n（2）奉献担当\n3、业绩说明：\n具备扎实的航运专业背景和丰富的实践经验，在船舶运营、港口协调及成本控制方面展现出卓越的协调能力，跨文化沟通能力突出。',
    descId: '1、Tingkat Kehadiran Tahunan：99.73%\n2、Kinerja Menonjol：\n（1）Prestasi Kerja Menonjol\n（2）Bertanggung Jawab & Berpengabdian\n3、Uraian Kinerja：\nMemiliki latar belakang yang kuat di bidang pelayaran dan pengalaman praktis yang luas; menunjukkan kemampuan koordinasi yang luar biasa dalam operasi kapal, komunikasi pelabuhan, dan pengendalian biaya, serta keterampilan komunikasi lintas budaya yang baik.',
    coverUrl: '/static/person/ipip9/photo.png',
    poster: '/static/person/ipip9/photo.png',
    videoUrl: '/static/person/ipip9/video.mp4'
  },
  {
    id: 'nj1',
    company: 'NJ',
    code: 'KNI-82003564',
    name: 'Faisal',
    nameId: 'Faisal',
    dept: '工程安环部',
    deptId: 'Dept. HSE',
    position: 'Engineer',
    itemDesc: '1、年度出勤率：100.00%\n2、突出表现：\n（1）创新改进\n（2）融合互助、见义勇为\n（3）奉献担当\n（4）进取成长\n3、业绩说明：\n工作热情高，团队协作好；作为环保工程师，按时高质量完成环境管理任务，积极支持现场HSE工作。',
    descId: '1、Tingkat Kehadiran Tahunan：100.00%\n2、Kinerja Menonjol：\n（1）Inovasi & Perbaikan Kerja\n（2）Gotong Royong Lintas Budaya & Berani Membela Keadilan\n（3）Bertanggung Jawab & Berpengabdian\n（4）Selalu Berkembang & Belajar\n3、Uraian Kinerja：\nMemiliki etos kerja yang tinggi dan kerja sama tim yang baik; sebagai engineer lingkungan, menyelesaikan tugas pengelolaan lingkungan dengan baik dan tepat waktu, serta aktif mendukung program HSE di lapangan.',
    coverUrl: '/static/person/nj1/photo.jpg',
    poster: '/static/person/nj1/photo.jpg',
    videoUrl: '/static/person/nj1/video.mp4'
  },
  {
    id: 'nj2',
    company: 'NJ',
    code: 'KNI-82003617',
    name: 'Pebrizal',
    nameId: 'Pebrizal',
    dept: '工程管理三部',
    deptId: 'Dept. Manajemen Engineering Ⅲ',
    position: 'Engineer',
    itemDesc: '1、年度出勤率：100.00%\n2、突出表现：\n（1）业绩突出\n（2）创新改进\n（3）奉献担当\n3、业绩说明：\n作为IPIP施工区域应急响应培训及室内培训的开创者，并负责重型设备合格性调试工作。',
    descId: '1、Tingkat Kehadiran Tahunan：100.00%\n2、Kinerja Menonjol：\n（1）Prestasi Kerja Menonjol\n（2）Inovasi & Perbaikan Kerja\n（3）Bertanggung Jawab & Berpengabdian\n3、Uraian Kinerja：\nSebagai pelopor pelatihan tanggap darurat dan in-class training di area konstruksi IPIP; melakukan commissioning uji kelayakan alat berat.',
    coverUrl: '/static/person/nj2/photo.png',
    poster: '/static/person/nj2/photo.png',
    videoUrl: '/static/person/nj2/video.mp4'
  },
  {
    id: 'nj3',
    company: 'NJ',
    code: 'KNI-8241001001',
    name: 'Ali Aqbar',
    nameId: 'Ali Aqbar',
    dept: '工程管理二部',
    deptId: 'Dept. Manajemen Engineering Ⅱ',
    position: 'Engineer',
    itemDesc: '1、年度出勤率：99.45%\n2、突出表现：\n（1）融合互助、见义勇为\n（2）奉献担当\n（3）进取成长\n3、业绩说明：\n能有效协调中印尼员工，团队工作积极主动，行政能力良好，认真执行现场K3监督任务。',
    descId: '1、Tingkat Kehadiran Tahunan：99.45%\n2、Kinerja Menonjol：\n（1）Gotong Royong Lintas Budaya & Berani Membela Keadilan\n（2）Bertanggung Jawab & Berpengabdian\n（3）Selalu Berkembang & Belajar\n3、Uraian Kinerja：\nMampu berkoordinasi dengan baik antara karyawan Indonesia dan Tiongkok; proaktif dalam pekerjaan tim, memiliki kemampuan administrasi yang baik, dan teliti dalam melaksanakan tugas pengawasan K3 di lapangan.',
    coverUrl: '/static/person/nj3/photo.png',
    poster: '/static/person/nj3/photo.png',
    videoUrl: '/static/person/nj3/video.mp4'
  },
  {
    id: 'hx1',
    company: 'HXNI',
    code: 'HXNI-00012',
    name: 'Aan Indrawan',
    nameId: 'Aan Indrawan',
    dept: '安全环保部',
    deptId: 'Dept. Environmental Health and Safety (EHS)',
    position: 'Operator',
    itemDesc: '1、年度出勤率：99.59%\n2、突出表现：\n（1）奉献担当\n（2）进取成长\n3、业绩说明：\n学习主动性强，积极参与讨论，熟练掌握K3规章制度；作为协管员兼翻译，有效沟通中印尼双方在现场K3执行中的工作。',
    descId: '1、Tingkat Kehadiran Tahunan：99.59%\n2、Kinerja Menonjol：\n（1）Bertanggung Jawab & Berpengabdian\n（2）Selalu Berkembang & Belajar\n3、Uraian Kinerja：\nMemiliki inisiatif belajar yang baik, aktif berdiskusi, dan mampu memahami peraturan K3; sebagai koordinator sekaligus penerjemah, menjembatani komunikasi antara pihak Tiongkok dan Indonesia dalam penerapan K3 di lapangan.',
    coverUrl: '/static/person/hx1/photo.png',
    poster: '/static/person/hx1/photo.png',
    videoUrl: '/static/person/hx1/video.mp4'
  },
  {
    id: 'hx2',
    company: 'HXNI',
    code: 'HXNI-00023',
    name: 'Saeful Nasar',
    nameId: 'Saeful Nasar',
    dept: '检修维护部',
    deptId: 'Dept. Maintenance',
    position: 'Operator',
    itemDesc: '1、年度出勤率：100.00%\n2、突出表现：\n（1）创新改进\n（2）奉献担当\n3、业绩说明：\n工作表现良好，能为团队做出积极贡献；作为电工班长，认真做好电气设备维护检修工作，保障设备稳定运行。',
    descId: '1、Tingkat Kehadiran Tahunan：100.00%\n2、Kinerja Menonjol：\n（1）Inovasi & Perbaikan Kerja\n（2）Bertanggung Jawab & Berpengabdian\n3、Uraian Kinerja：\nBekerja dengan baik dan mampu berkontribusi positif dalam tim; sebagai foreman listrik, teliti dalam melakukan perawatan dan perbaikan peralatan listrik, serta memastikan kelancaran operasional peralatan.',
    coverUrl: '/static/person/hx2/photo.jpg',
    poster: '/static/person/hx2/photo.jpg',
    videoUrl: '/static/person/hx2/video.mp4'
  },
  {
    id: 'hx3',
    company: 'HXNI',
    code: 'HXNI-00045',
    name: 'Elshaday Loffeybi Berlian',
    nameId: 'Elshaday Loffeybi Berlian',
    dept: '质量保证部',
    deptId: 'Dept. Quality Assurance',
    position: 'Operator',
    itemDesc: '1、年度出勤率：100.00%\n2、突出表现：\n（1）业绩突出\n（2）创新改进\n（3）融合互助、见义勇为\n（4）奉献担当\n（5）进取成长\n3、业绩说明：\n工作表现良好，团队沟通顺畅；作为化验员，认真进行样品检测，确保实验室检测数据准确可靠。',
    descId: '1、Tingkat Kehadiran Tahunan：100.00%\n2、Kinerja Menonjol：\n（1）Prestasi Kerja Menonjol\n（2）Inovasi & Perbaikan Kerja\n（3）Gotong Royong Lintas Budaya & Berani Membela Keadilan\n（4）Bertanggung Jawab & Berpengabdian\n（5）Selalu Berkembang & Belajar\n3、Uraian Kinerja：\nBekerja dengan baik dan memiliki komunikasi yang baik dengan tim; sebagai staf analisis, teliti dalam melakukan pengujian sampel dan memastikan akurasi data hasil uji laboratorium.',
    coverUrl: '/static/person/hx3/photo.jpg',
    poster: '/static/person/hx3/photo.jpg',
    videoUrl: '/static/person/hx3/video.mov'
  },
  {
    id: 'hx4',
    company: 'HXNI',
    code: 'HXNI-00047',
    name: 'Muh. Irham Rozali',
    nameId: 'Muh. Irham Rozali',
    dept: '冶炼厂',
    deptId: 'Smelter',
    position: 'Operator',
    itemDesc: '1、年度出勤率：100.00%\n2、突出表现：\n（1）融合互助、见义勇为\n（2）奉献担当\n（3）进取成长\n3、业绩说明：\n工作热情饱满，能融入团结协作的团队；作为吹炼炉炉后工，认真执行操作任务，支持冶炼厂生产目标达成。',
    descId: '1、Tingkat Kehadiran Tahunan：100.00%\n2、Kinerja Menonjol：\n（1）Gotong Royong Lintas Budaya & Berani Membela Keadilan\n（2）Bertanggung Jawab & Berpengabdian\n（3）Selalu Berkembang & Belajar\n3、Uraian Kinerja：\nMemiliki semangat kerja yang baik dan mampu bekerja sama dalam tim yang solid; sebagai kru blown furnace, menjalankan tugas operasional dengan teliti dan mendukung pencapaian target produksi smelter.',
    coverUrl: '/static/person/hx4/photo.jpg',
    poster: '/static/person/hx4/photo.jpg',
    videoUrl: '/static/person/hx4/video.mp4'
  },
  {
    id: 'hx5',
    company: 'HXNI',
    code: 'HXNI-00050',
    name: 'Muh. Hasbi',
    nameId: 'Muh. Hasbi',
    dept: '冶炼厂',
    deptId: 'Smelter',
    position: 'Operator',
    itemDesc: '1、年度出勤率：99.73%\n2、突出表现：\n（1）奉献担当\n3、业绩说明：\n工作全身心投入，能承受工作压力，团队协作良好；作为吹炼炉炉后工，为生产流程顺畅做出贡献，始终把安全放在首位。',
    descId: '1、Tingkat Kehadiran Tahunan：99.73%\n2、Kinerja Menonjol：\n（1）Bertanggung Jawab & Berpengabdian\n3、Uraian Kinerja：\nBekerja dengan totalitas, mampu bekerja di bawah tekanan, dan bekerja sama dengan baik dalam tim; sebagai kru blown furnace, berkontribusi pada kelancaran proses produksi dan selalu mengutamakan keselamatan.',
    coverUrl: '/static/person/hx5/photo.jpg',
    poster: '/static/person/hx5/photo.jpg',
    videoUrl: '/static/person/hx5/video.mp4'
  },
  {
    id: 'hx6',
    company: 'HXNI',
    code: 'HXNI-00052',
    name: 'Andi Kasram',
    nameId: 'Andi Kasram',
    dept: '冶炼厂',
    deptId: 'Smelter',
    position: 'Operator',
    itemDesc: '1、年度出勤率：99.73%\n2、突出表现：\n（1）融合互助、见义勇为\n（2）奉献担当\n（3）进取成长\n3、业绩说明：\n工作认真负责，工作成果良好；作为吹炼炉炉后工，严格遵守操作规程，维护冶炼区域安全生产。',
    descId: '1、Tingkat Kehadiran Tahunan：99.73%\n2、Kinerja Menonjol：\n（1）Gotong Royong Lintas Budaya & Berani Membela Keadilan\n（2）Bertanggung Jawab & Berpengabdian\n（3）Selalu Berkembang & Belajar\n3、Uraian Kinerja：\nSerius dalam bekerja dan memberikan hasil kerja yang baik; sebagai kru blown furnace, melaksanakan prosedur operasional dengan disiplin dan menjaga keselamatan kerja di area smelter.',
    coverUrl: '/static/person/hx6/photo.jpg',
    poster: '/static/person/hx6/photo.jpg',
    videoUrl: '/static/person/hx6/video.mp4'
  },
  {
    id: 'hx7',
    company: 'HXNI',
    code: 'HXNI-00057',
    name: 'Ifan Fadly Firdaus',
    nameId: 'Ifan Fadly Firdaus',
    dept: '动力厂',
    deptId: 'Power Plant',
    position: 'Operator',
    itemDesc: '1、年度出勤率：100.00%\n2、突出表现：\n（1）进取成长\n3、业绩说明：\n工作表现良好，能承受工作压力；作为巡检工，定期检查锅炉、发电及水处理设备运行状况，及时上报潜在问题。',
    descId: '1、Tingkat Kehadiran Tahunan：100.00%\n2、Kinerja Menonjol：\n（1）Selalu Berkembang & Belajar\n3、Uraian Kinerja：\nBekerja dengan baik dan mampu bekerja di bawah tekanan; sebagai kru inspeksi, rutin memeriksa kondisi boiler, pembangkit listrik, dan pengolahan air, serta melaporkan potensi masalah secara dini.',
    coverUrl: '/static/person/hx7/photo.png',
    poster: '/static/person/hx7/photo.png',
    videoUrl: '/static/person/hx7/video.mp4'
  },
  {
    id: 'hx8',
    company: 'HXNI',
    code: 'HXNI-00062',
    name: 'Andi Ahmad Ashshiddiq Mufti',
    nameId: 'Andi Ahmad Ashshiddiq Mufti',
    dept: '冶炼厂',
    deptId: 'Smelter',
    position: 'Operator',
    itemDesc: '1、年度出勤率：99.73%\n2、突出表现：\n（1）融合互助、见义勇为\n3、业绩说明：\n工作表现良好，能为团队做出积极贡献；作为干燥窑皮带工，认真操作和监控皮带设备，保障生产顺畅。',
    descId: '1、Tingkat Kehadiran Tahunan：99.73%\n2、Kinerja Menonjol：\n（1）Gotong Royong Lintas Budaya & Berani Membela Keadilan\n3、Uraian Kinerja：\nBekerja dengan baik dan mampu berkontribusi positif dalam tim; sebagai kru conveyor dryer, menjalankan tugas pengoperasian dan pemantauan conveyor dengan teliti untuk mendukung kelancaran produksi.',
    coverUrl: '/static/person/hx8/photo.jpg',
    poster: '/static/person/hx8/photo.jpg',
    videoUrl: '/static/person/hx8/video.mp4'
  },
  {
    id: 'hx9',
    company: 'HXNI',
    code: 'HXNI-00312',
    name: 'Muh Aldin Latamua',
    nameId: 'Muh Aldin Latamua',
    dept: '储运物流部',
    deptId: 'Dept. Management Gudang dan Logistik',
    position: 'Operator',
    itemDesc: '1、年度出勤率：100.00%\n2、突出表现：\n（1）融合互助、见义勇为\n（2）奉献担当\n3、业绩说明：\n适应能力强，工作表现良好，团队协作融洽；作为仓储管理员，认真做好物资记录与整理，确保库存数据准确。',
    descId: '1、Tingkat Kehadiran Tahunan：100.00%\n2、Kinerja Menonjol：\n（1）Gotong Royong Lintas Budaya & Berani Membela Keadilan\n（2）Bertanggung Jawab & Berpengabdian\n3、Uraian Kinerja：\nMampu beradaptasi dan bekerja dengan baik, serta bekerja sama dengan baik dalam tim; sebagai staf manajemen gudang, teliti dalam pencatatan dan penataan barang, memastikan akurasi data stok.',
    coverUrl: '/static/person/hx9/photo.jpg',
    poster: '/static/person/hx9/photo.jpg',
    videoUrl: '/static/person/hx9/video.mp4'
  },
  {
    id: 'kni1',
    company: 'KNI',
    code: 'KNI-8251215001',
    name: 'Faiz Zaki Murfid',
    nameId: 'Faiz Zaki Murfid',
    dept: '检修维护部',
    deptId: 'Dept. Pemeliharaan dan Perbaikan',
    position: 'Operator',
    itemDesc: '1、年度出勤率：98.35%\n2、突出表现：\n（1）业绩突出\n（2）创新改进\n（3）融合互助、见义勇为\n（4）奉献担当\n（5）进取成长\n3、业绩说明：\n作为优秀的辐射防护人员，成功建立并实施辐射防护体系。',
    descId: '1、Tingkat Kehadiran Tahunan：98.35%\n2、Kinerja Menonjol：\n（1）Prestasi Kerja Menonjol\n（2）Inovasi & Perbaikan Kerja\n（3）Gotong Royong Lintas Budaya & Berani Membela Keadilan\n（4）Bertanggung Jawab & Berpengabdian\n（5）Selalu Berkembang & Belajar\n3、Uraian Kinerja：\nSebagai petugas proteksi radiasi yang unggul, berhasil membangun dan mengimplementasikan sistem proteksi radiasi.',
    coverUrl: '/static/person/kni1/photo.jpg',
    poster: '/static/person/kni1/photo.jpg',
    videoUrl: '/static/person/kni1/video.mp4'
  },
  {
    id: 'kni2',
    company: 'KNI',
    code: 'KNI-8251125001',
    name: 'Fiviniarti',
    nameId: 'Fiviniarti',
    dept: '选矿厂',
    deptId: 'Feed Preparation Plant',
    position: 'Operator',
    itemDesc: '1、年度出勤率：96.69%\n2、突出表现：\n（1）进取成长\n3、业绩说明：\n翻译能力出色，能有效协调中印尼员工沟通；作为综合管理员，同时保障部门行政与文档工作顺利开展。',
    descId: '1、Tingkat Kehadiran Tahunan：96.69%\n2、Kinerja Menonjol：\n（1）Selalu Berkembang & Belajar\n3、Uraian Kinerja：\nPenerjemah yang unggul dan mampu mengoordinasikan komunikasi antara karyawan Tiongkok dan Indonesia; sebagai general administrator, juga mendukung kelancaran administrasi dan dokumentasi departemen.',
    coverUrl: '/static/person/kni2/photo.jpg',
    poster: '/static/person/kni2/photo.jpg',
    videoUrl: '/static/person/kni2/video.mp4'
  },
  {
    id: 'kni3',
    company: 'KNI',
    code: 'KNI-8251230002',
    name: 'Hendra',
    nameId: 'Hendra',
    dept: '硫酸厂',
    deptId: 'Sulfuric Acid Plant',
    position: 'Operator',
    itemDesc: '1、年度出勤率：98.58%\n2、突出表现：\n（1）业绩突出\n3、业绩说明：\n团队领导能力强，工作纪律性好；作为发电运行副班长，确保发电设备稳定安全运行。',
    descId: '1、Tingkat Kehadiran Tahunan：98.58%\n2、Kinerja Menonjol：\n（1）Prestasi Kerja Menonjol\n3、Uraian Kinerja：\nMampu memimpin tim dengan baik dan memiliki disiplin kerja yang baik; sebagai foreman operasi pembangkit, memastikan pengoperasian peralatan berjalan stabil dan aman.',
    coverUrl: '/static/person/kni3/photo.jpg',
    poster: '/static/person/kni3/photo.jpg',
    videoUrl: '/static/person/kni3/video.mp4'
  },
  {
    id: 'kni4',
    company: 'KNI',
    code: 'KNI-8251021004',
    name: 'Nafa Fitria Islami',
    nameId: 'Nafa Fitria Islami',
    dept: '质量保证部',
    deptId: 'Dept. Quality Assurance',
    position: 'Operator',
    itemDesc: '1、年度出勤率：98.53%\n2、突出表现：\n（1）业绩突出\n（2）奉献担当\n（3）进取成长\n3、业绩说明：\n工作细致准确，设备操作熟练；作为化验助理（储备人才），认真协助实验室检测工作，持续提升自身能力。',
    descId: '1、Tingkat Kehadiran Tahunan：98.53%\n2、Kinerja Menonjol：\n（1）Prestasi Kerja Menonjol\n（2）Bertanggung Jawab & Berpengabdian\n（3）Selalu Berkembang & Belajar\n3、Uraian Kinerja：\nTeliti dan akurat dalam bekerja, serta mampu mengoperasikan alat dengan baik; sebagai asisten analis, mendukung kegiatan pengujian laboratorium dengan cermat dan terus mengembangkan kemampuan diri.',
    coverUrl: '/static/person/kni4/photo.jpg',
    poster: '/static/person/kni4/photo.jpg',
    videoUrl: '/static/person/kni4/video.mp4'
  },
  {
    id: 'kni5',
    company: 'KNI',
    code: 'KNI-8260203001',
    name: 'Rizki Harianto',
    nameId: 'Rizki Harianto',
    dept: '安全环保部',
    deptId: 'Dept. K3LH',
    position: 'Operator',
    itemDesc: '1、年度出勤率：100.00%\n2、突出表现：\n（1）业绩突出\n（2）创新改进\n（3）奉献担当\n（4）进取成长\n3、业绩说明：\n工作细致认真，责任心强，具备良好的领导能力；作为安环主管，监督现场K3执行，指导团队落实安全规程。',
    descId: '1、Tingkat Kehadiran Tahunan：100.00%\n2、Kinerja Menonjol：\n（1）Prestasi Kerja Menonjol\n（2）Inovasi & Perbaikan Kerja\n（3）Bertanggung Jawab & Berpengabdian\n（4）Selalu Berkembang & Belajar\n3、Uraian Kinerja：\nTeliti, memiliki tanggung jawab yang tinggi, dan mampu memimpin dengan baik; sebagai supervisor K3, mengawasi penerapan K3 di lapangan dan membimbing tim dalam menjalankan prosedur keselamatan.',
    coverUrl: '/static/person/kni5/photo.jpg',
    poster: '/static/person/kni5/photo.jpg',
    videoUrl: '/static/person/kni5/video.mp4'
  },
  {
    id: 'kni6',
    company: 'KNI',
    code: 'KNI-8251216003',
    name: 'Sanib Baharuddin',
    nameId: 'Sanib Baharuddin',
    dept: '办公室',
    deptId: 'Dept. Kantor',
    position: 'Operator',
    itemDesc: '1、年度出勤率：98.97%\n2、突出表现：\n（1）进取成长\n3、业绩说明：\n工作纪律严明，对本职工作认真负责；作为皮卡车司机，严格遵守交通规则和安全驾驶规程，确保人员与物资运送安全准时。',
    descId: '1、Tingkat Kehadiran Tahunan：98.97%\n2、Kinerja Menonjol：\n（1）Selalu Berkembang & Belajar\n3、Uraian Kinerja：\nDisiplin dalam bekerja dan bertanggung jawab terhadap pekerjaan; sebagai driver LV, selalu mematuhi peraturan lalu lintas dan prosedur keselamatan berkendara, memastikan pengantaran barang dan personil berjalan aman dan tepat waktu.',
    coverUrl: '/static/person/kni6/photo.jpg',
    poster: '/static/person/kni6/photo.jpg',
    videoUrl: '/static/person/kni6/video.mp4'
  },
  {
    id: 'hbb1',
    company: 'HBB',
    code: '82001614',
    name: '黄油明',
    nameId: 'BONGJIU MEN',
    dept: '基建部',
    deptId: 'Infrastruktur',
    position: 'Staff',
    itemDesc: '1、年度出勤率：100.00%\n2、突出表现：\n（1）业绩突出\n（2）奉献担当\n（3）进取成长\n3、业绩说明：\n具备团队组织与管理能力；作为副班长兼翻译，协调基建施工工作，沟通中印尼双方现场作业人员。',
    descId: '1、Tingkat Kehadiran Tahunan：100.00%\n2、Kinerja Menonjol：\n（1）Prestasi Kerja Menonjol\n（2）Bertanggung Jawab & Berpengabdian\n（3）Selalu Berkembang & Belajar\n3、Uraian Kinerja：\nMemiliki kemampuan dalam mengatur dan memimpin tim; sebagai vice foreman sekaligus penerjemah, mengoordinasikan pekerjaan konstruksi dan menjembatani komunikasi antara pekerja Tiongkok dan Indonesia di lapangan.',
    coverUrl: '/static/person/hbb1/photo.png',
    poster: '/static/person/hbb1/photo.png',
    videoUrl: '/static/person/hbb1/video.mp4'
  },
  {
    id: 'hbb2',
    company: 'HBB',
    code: 'HBB-00043',
    name: 'ASURA ABDULLAH',
    nameId: 'ASURA ABDULLAH',
    dept: '安全环保部',
    deptId: 'HSE',
    position: 'Staff',
    itemDesc: '1、年度出勤率：99.73%\n2、突出表现：\n（1）融合互助、见义勇为\n（2）奉献担当\n3、业绩说明：\n具备K3专业知识；作为安全员，积极开展现场安全检查，提醒作业人员遵守K3规程，助力营造安全工作环境。',
    descId: '1、Tingkat Kehadiran Tahunan：99.73%\n2、Kinerja Menonjol：\n（1）Gotong Royong Lintas Budaya & Berani Membela Keadilan\n（2）Bertanggung Jawab & Berpengabdian\n3、Uraian Kinerja：\nMemiliki pengetahuan yang baik mengenai K3; sebagai safety staff, aktif melakukan inspeksi keselamatan di lapangan, mengingatkan pekerja untuk mematuhi prosedur K3, dan mendukung terciptanya lingkungan kerja yang aman.',
    coverUrl: '/static/person/hbb2/photo.png',
    poster: '/static/person/hbb2/photo.png',
    videoUrl: '/static/person/hbb2/video.mp4'
  },
  {
    id: 'hbb3',
    company: 'HBB',
    code: 'HBB-00035',
    name: '伊万',
    nameId: 'IRWAN',
    dept: '物资管理部',
    deptId: 'Manajemen Material',
    position: 'Staff',
    itemDesc: '1、年度出勤率：100.00%\n2、突出表现：\n（1）奉献担当\n（2）进取成长\n3、业绩说明：\n能够准确翻译工作指令和指示；作为协管员兼翻译，保障物资管理及现场团队协调沟通顺畅。',
    descId: '1、Tingkat Kehadiran Tahunan：100.00%\n2、Kinerja Menonjol：\n（1）Bertanggung Jawab & Berpengabdian\n（2）Selalu Berkembang & Belajar\n3、Uraian Kinerja：\nMampu menerjemahkan perintah dan instruksi kerja dengan akurat; sebagai koordinator dan penerjemah, mendukung kelancaran komunikasi dalam pengelolaan material dan koordinasi antar tim di lapangan.',
    coverUrl: '/static/person/hbb3/photo.png',
    poster: '/static/person/hbb3/photo.png',
    videoUrl: '/static/person/hbb3/video.mp4'
  },
]

// 根据候选人 id 查找静态信息
export function getRealCandidateById (id) {
  return REAL_CANDIDATES.find(c => c.id === id) || null
}


// WEBPACK FOOTER //
// ./src/data/realCandidates.js